import { getSftpPgpKey } from "../../services/defs/internal-api";

export const SFTP_PGP_KEY_QUERY_KEY = "sftp-pgp-key";

export const sftpPgpKeyQuery = () => ({
	queryKey: [SFTP_PGP_KEY_QUERY_KEY] as const,
	queryFn: () => getSftpPgpKey(),
	meta: {
		errorMessage: "There was an error loading your PGP key.",
	},
});
